import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export interface DetailFieldRow {
  label: string;
  value: React.ReactNode;
}

export interface DetailFieldGridProps {
  rows: DetailFieldRow[];
  "data-testid"?: string;
}

const DetailFieldGrid: React.FC<DetailFieldGridProps> = ({
  rows,
  "data-testid": dataTestId
}) => {
  const theme = useTheme();
  const accent = theme.palette.primary.main;

  return (
    <Paper
      elevation={0}
      data-testid={dataTestId}
      sx={{
        borderRadius: 2.5,
        overflow: "hidden",
        border: `1px solid ${alpha(accent, 0.1)}`,
        bgcolor: "background.paper"
      }}
    >
      {rows.map((row, index) => (
        <Box
          key={row.label}
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "minmax(140px, 1fr) 2fr" },
            gap: { xs: 0.5, sm: 0 },
            px: { xs: 2, sm: 2.5 },
            py: 1.5,
            borderBottom:
              index === rows.length - 1
                ? "none"
                : `1px solid ${alpha(accent, 0.08)}`,
            bgcolor: index % 2 === 0 ? alpha(accent, 0.02) : "transparent"
          }}
        >
          <Typography
            variant="body2"
            fontWeight={600}
            color="text.secondary"
            sx={{ fontSize: "0.8125rem" }}
          >
            {row.label}
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: "0.875rem", minWidth: 0 }}
          >
            {row.value ?? "-"}
          </Typography>
        </Box>
      ))}
    </Paper>
  );
};

export default DetailFieldGrid;
